import React from 'react';
import { motion } from 'framer-motion';

const LOGO = 'https://customer-assets-4nw71qhi.emergentagent.net/job_83ef92c5-3c5d-4a35-b89a-364f4b1c35a2/artifacts/9u15ynr8_1000X1000%20WHITE.png';

// Clean, minimal boot loader. White AV mark on a solid dark field, matched to the
// native iOS launch screen for a seamless hand-off. Logo stays fully visible.
export const LoadingScreen = () => {
  return (
    <div
      data-testid="loading-screen"
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
      style={{ backgroundColor: '#0c0a09', minHeight: '100dvh' }}
    >
      <motion.img
        src={LOGO}
        alt="Ami Video"
        className="h-32 w-auto md:h-40 select-none"
        draggable={false}
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: [0.96, 1, 0.98, 1] }}
        transition={{
          opacity: { duration: 0.9, ease: 'easeOut' },
          scale: { duration: 4.5, ease: 'easeInOut', repeat: Infinity },
        }}
      />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.8 }}
        className="mt-9 h-px w-14 overflow-hidden bg-white/15"
      >
        <motion.div
          className="h-full w-1/2 bg-white/70"
          initial={{ x: '-120%' }}
          animate={{ x: '260%' }}
          transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
        />
      </motion.div>
    </div>
  );
};

export default LoadingScreen;
